import React from 'react';
import { useSpinner } from '../../Context/SpinnerContext';
import { LoaderCircle } from 'lucide-react';

const Spinner = () => {
  const { isSpinnerVisible, spinnerText } = useSpinner();

  if (!isSpinnerVisible) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-[rgba(255,255,255,0.5)] z-[100] flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-xl flex flex-col items-center">
        <LoaderCircle className="animate-spin text-green-500 h-16 w-16 mb-4" />
        <p className="text-lg">{spinnerText}</p>
      </div>
    </div>
  );
};

export default Spinner;
